import * as React from 'react';
import { DropdownList } from 'react-widgets';
import { FilterProps } from './types';

function dropdownOrderFilter<T extends Record<string, unknown>>(
    data: SelectObject[],
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    containerClassName?: string,
): React.FunctionComponent<FilterProps<T>> {
    return React.memo(({ column: { filterValue, setFilter } }: FilterProps<T>) => {
        const handleChange = (item: SelectObject) => {
            setFilter(item.value ? item.value : '');
        };

        return (
            <DropdownList
                containerClassName={containerClassName}
                data={[{ label: 'All', value: 'all' }, ...data]}
                textField="label"
                valueField="value"
                onChange={handleChange}
                value={filterValue ? filterValue : undefined}
            />
        );
    });
}

export default dropdownOrderFilter;
